/** 隐私协议声明 */
// import * as types from '../mutationTypes'
const state = {
  protocols: {},
  // 是否展示隐私协议内容查看弹窗
  isShowContent: false,
  // 是否展示隐私协议声明更新的提示弹窗
  isShowNotice: false
}

const mutations = {
  // 设置协议查看弹窗是否展示
  setShowContent (state, data) {
    state.isShowContent = data
  },
  // 设置协议更新通知弹窗是否展示
  setShowNotice (state, data) {
    state.isShowNotice = data
  },
  setProtocols (state, payload) {
    state.protocols = payload
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
